import React, { Component } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  TextField,
  Typography,
  Skeleton,
  Pagination,
  Tabs,
  Tab,
  Badge,
  IconButton,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import CustomizedSnackbars from '../../components/material-snackbars';
import HeaderMenu from '../../components/header-menu';
import Footer from '../../components/footer';
import { injectIntl } from 'react-intl';
import * as componentActions from '../../redux/actions/integrationauths';
import { Add as AddIcon, Campaign as CampaignIcon, Settings as SettingsIcon } from '@mui/icons-material';
import AnnouncementCard from './AnnouncementCard';
import AnnouncementDetail from './AnnouncementDetail';
import AnnouncementManageGrid from './AnnouncementManageGrid';
import AnnouncementSettingsDialog from './AnnouncementSettingsDialog';
import { getMural, getMuralItem, getSettings, getUnreadCount } from '../../services/announcement.service';
import { AbilityContext } from '../../config/ability-context';
import { useAgentWorkspaceHubContext } from '../../contexts/AgentWorkspaceHubContext';

const PAGE_SIZE = 10;

class AnnouncementList extends Component {
  constructor(props) {
    super(props);
    const initialTab = new URLSearchParams(props.location ? props.location.search : '').get('tab') === 'manage'
      ? 'manage'
      : 'active';
    this.state = {
      tab: initialTab,
      items: [],
      total: 0,
      page: 1,
      loading: false,
      selectedId: null,
      selected: null,
      detailLoading: false,
      search: '',
      settings: null,
      snackOpen: false,
      snackVariant: 'error',
      snackMessage: '',
      settingsOpen: false,
      manageReloadToken: 0,
      unreadCount: 0,
    };

    this._nbDebounce = null;

    this.isAdm = false;
    this.isClient = true;
    this.isAdmOrg = false;
    this.isAdmGlobal = false;
    this.isTec = false;

    const { userSession } = props;
    if (userSession?.user?.userrole) {
      userSession.user.userrole.forEach((item) => {
        if (item.role.roletype !== 3) {
          this.isClient = false;
        }
        if (item.role.roletype === 0 || item.role.roletype === 1 || item.role.roletype === 6 || item.role.roletype === 4) {
          this.isAdm = true;
          if (item.role.roletype === 0) {
            this.isAdmGlobal = true;
          }
        }
        if (item.role.roletype === 1 && item.role.roletype !== 0 && !this.isAdmGlobal) {
          this.isAdmOrg = true;
        }
        if (item.role.roletype === 2) {
          this.isTec = true;
        }
      });
    }
  }

  componentDidMount() {
    this.loadSettings();
    this.loadActive();
    this.loadUnreadCount();
  }

  componentDidUpdate(prevProps) {
    const prev = prevProps.hubAnnouncementChange;
    const curr = this.props.hubAnnouncementChange;
    if (!curr || (prev && prev.seq === curr.seq)) return;

    const announcementId = curr.announcementId;
    const changeKind = curr.changeKind;

    if (['closed', 'archived', 'deleted'].indexOf(changeKind) !== -1 && this.state.selectedId === announcementId) {
      this.setState({ selectedId: null, selected: null });
    } else if (changeKind === 'updated' && this.state.selectedId === announcementId) {
      this.onSelect(announcementId);
    }

    if (this._nbDebounce) clearTimeout(this._nbDebounce);
    this._nbDebounce = setTimeout(() => {
      if (this.state.tab === 'active') this.loadActive(1);
      this.loadUnreadCount();
      this.setState((s) => ({ manageReloadToken: (s.manageReloadToken || 0) + 1 }));
    }, 500);
  }

  componentWillUnmount() {
    if (this._nbDebounce) clearTimeout(this._nbDebounce);
  }

  loadSettings = async () => {
    try {
      const r = await getSettings();
      const s = r?.data?.data ?? r?.data ?? null;
      this.setState({ settings: s });
    } catch (e) {
    }
  };

  loadUnreadCount = async () => {
    try {
      const r = await getUnreadCount();
      const body = r?.data?.data ?? r?.data ?? null;
      const count = body && typeof body.count === 'number' ? body.count : 0;
      this.setState({ unreadCount: count });
      try {
        window.dispatchEvent(new CustomEvent('mexx:announcement-unread-changed', { detail: { count } }));
      } catch (e) {}
    } catch (e) {
    }
  };

  resolveErrorMessage = (e) => {
    const intl = this.props.intl;
    const status = e?.response?.status;
    const serverMessage = e?.response?.data?.errors?.[0] ?? e?.response?.data?.erros?.[0];
    if (serverMessage) return serverMessage;
    if (status === 401 || status === 403) {
      return intl.formatMessage({ id: 'noticeboard.mural.forbidden' });
    }
    return intl.formatMessage({ id: 'process.error' });
  };

  loadActive = async (page = 1) => {
    this.setState({ loading: true });
    try {
      const r = await getMural(page, PAGE_SIZE);
      const items = r?.data?.data ?? [];
      const total = r?.data?.count ?? 0;
      this.setState({ items, total, page, loading: false });
    } catch (e) {
      this.setState({
        loading: false,
        snackOpen: true,
        snackVariant: 'error',
        snackMessage: this.resolveErrorMessage(e),
      });
    }
  };

  onSelect = async (id) => {
    this.setState({ selectedId: id, detailLoading: true });
    try {
      const r = await getMuralItem(id);
      const d = r?.data?.data ?? r?.data ?? null;
      this.setState({ selected: d, detailLoading: false });
      if (d) {
        this.setState((st) => ({
          items: st.items.map((x) => (x.id === id ? { ...x, isread: true } : x)),
        }));
        this.loadUnreadCount();
      }
    } catch (e) {
      this.setState({
        detailLoading: false,
        snackOpen: true,
        snackVariant: 'error',
        snackMessage: this.resolveErrorMessage(e),
      });
    }
  };

  handleCloseSnack = () => {
    this.setState({ snackOpen: false });
  };

  handleTabChange = (event, newValue) => {
    this.setState({ tab: newValue });
    const lang = this.getLang();
    const qs = newValue === 'manage' ? '?tab=manage' : '';
    this.props.history.replace(`/${lang}/announcement${qs}`);
  };

  handlePageChange = (event, value) => {
    this.loadActive(value);
  };

  getLang() {
    return this.props.match?.params?.lang ?? 'pt';
  }

  getFilteredItems = () => {
    const { items, search } = this.state;
    if (!search.trim()) return items;
    const term = search.toLowerCase();
    return items.filter((i) => i.title.toLowerCase().includes(term));
  };

  render() {
    const { classes, headerMenu, actionsHeaderMenu, intl } = this.props;
    const {
      tab,
      items,
      total,
      page,
      loading,
      selectedId,
      selected,
      detailLoading,
      search,
      settings,
      snackOpen,
      snackVariant,
      snackMessage,
      settingsOpen,
      unreadCount,
    } = this.state;
    const lang = this.getLang();

    const canManage = this.isAdmGlobal || this.isAdmOrg || this.isTec;
    const canCreate = this.isAdmGlobal || this.isAdmOrg || (this.isTec && settings?.techniciancancreate === true);
    const canEditSettings = this.isAdmGlobal;

    const filteredItems = this.getFilteredItems();
    const pageCount = Math.ceil(total / PAGE_SIZE);

    return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
          style={{ paddingTop: 'calc(6px + var(--mexx-breadcrumb-height, 0px))', paddingBottom: 0 }}
        >
          <div className={classes.drawerHeader} />

          <Box sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 64px - var(--mexx-breadcrumb-height, 0px))', overflow: 'hidden', px: 2, pt: 2, gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12),
                  }}
                >
                  <CampaignIcon sx={{ color: 'primary.main' }} />
                </Box>
                <Typography sx={{ fontSize: 20, fontWeight: 700 }}>
                  {intl.formatMessage({ id: 'noticeboard.page.title' })}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {canEditSettings && (
                  <IconButton
                    size="small"
                    onClick={() => this.setState({ settingsOpen: true })}
                    sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '10px' }}
                  >
                    <SettingsIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
            </Box>

            {canManage && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                  gap: 1.5,
                  borderBottom: '1px solid',
                  borderColor: 'divider',
                }}
              >
                <Tabs
                  value={tab}
                  onChange={this.handleTabChange}
                  sx={{
                    minHeight: 0,
                    '& .MuiTabs-indicator': { height: 3, borderRadius: '3px', backgroundColor: 'primary.main' },
                  }}
                >
                  <Tab
                    value="active"
                    sx={{ textTransform: 'none', fontWeight: 600, minHeight: 0, py: 1.25, '&.Mui-selected': { color: 'primary.main' } }}
                    label={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {intl.formatMessage({ id: 'noticeboard.tab.active' })}
                        {unreadCount > 0 && (
                          <Badge
                            badgeContent={unreadCount}
                            max={999}
                            color="default"
                            sx={{
                              '& .MuiBadge-badge': {
                                position: 'static',
                                transform: 'none',
                                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.14),
                                color: 'primary.main',
                                fontWeight: 700,
                              },
                            }}
                          />
                        )}
                      </Box>
                    }
                  />
                  <Tab
                    value="manage"
                    sx={{ textTransform: 'none', fontWeight: 600, minHeight: 0, py: 1.25, '&.Mui-selected': { color: 'primary.main' } }}
                    label={intl.formatMessage({ id: 'noticeboard.tab.manage' })}
                  />
                </Tabs>

                {canCreate && (
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={() => this.props.history.push(`/${lang}/announcement-register${tab === 'manage' ? '?tab=manage' : ''}`)}
                    sx={{ textTransform: 'none', borderRadius: '10px', px: 4, mb: 1 }}
                  >
                    {intl.formatMessage({ id: 'noticeboard.new' })}
                  </Button>
                )}
              </Box>
            )}

            {tab === 'active' && !loading && total === 0 && (
              <Box
                sx={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: '60vh',
                  textAlign: 'center',
                  color: 'text.secondary',
                  pb: 2,
                }}
              >
                <CampaignIcon sx={{ fontSize: 56, opacity: 0.3, mb: 2 }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 400 }}>
                  {intl.formatMessage({ id: 'noticeboard.empty.title' })}
                </Typography>
              </Box>
            )}

            {tab === 'active' && (loading || total > 0) && (
              <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden', minHeight: '60vh', gap: 2, pb: 2 }}>
                <Box
                  sx={{
                    width: 360,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: '14px',
                    bgcolor: 'background.paper',
                  }}
                >
                  <Box sx={{ px: 1.5, py: 1 }}>
                    <TextField
                      fullWidth
                      placeholder={intl.formatMessage({ id: 'noticeboard.search.placeholder' })}
                      value={search}
                      onChange={(e) => this.setState({ search: e.target.value })}
                      size="small"
                      variant="outlined"
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    />
                  </Box>
                  <Box sx={{ flex: 1, overflowY: 'auto', px: 1.5, pb: 1 }}>
                    {loading && (
                      <>
                        {[1, 2, 3].map((i) => (
                          <Skeleton key={i} variant="rectangular" height={100} sx={{ mb: 1, borderRadius: '10px' }} />
                        ))}
                      </>
                    )}
                    {!loading && filteredItems.length === 0 && (
                      <Typography variant="body2" color="text.secondary" sx={{ p: 2, textAlign: 'center' }}>
                        {intl.formatMessage({ id: 'noticeboard.search.empty' })}
                      </Typography>
                    )}
                    {!loading && filteredItems.map((item) => (
                      <AnnouncementCard
                        key={item.id}
                        item={item}
                        selected={item.id === selectedId}
                        onClick={() => this.onSelect(item.id)}
                        intl={intl}
                      />
                    ))}
                  </Box>
                  {!loading && total > PAGE_SIZE && (
                    <Box sx={{ p: 1.5, display: 'flex', justifyContent: 'center', borderTop: '1px solid', borderColor: 'divider' }}>
                      <Pagination
                        count={pageCount}
                        page={page}
                        onChange={this.handlePageChange}
                        size="small"
                        shape="rounded"
                      />
                    </Box>
                  )}
                </Box>

                <Box
                  sx={{
                    flex: 1,
                    p: 3,
                    overflow: 'auto',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: '14px',
                    bgcolor: 'background.paper',
                  }}
                >
                  <AnnouncementDetail
                    item={selected}
                    loading={detailLoading}
                    intl={intl}
                  />
                </Box>
              </Box>
            )}

            {tab === 'manage' && (
              <Box sx={{ flex: 1, overflow: 'auto', pb: 2 }}>
                <AnnouncementManageGrid intl={intl} history={this.props.history} lang={lang} reloadToken={this.state.manageReloadToken} />
              </Box>
            )}
          </Box>

          <CustomizedSnackbars
            variant={snackVariant}
            message={snackMessage}
            isOpen={snackOpen}
            toClose={this.handleCloseSnack}
          />
        </main>
        <AnnouncementSettingsDialog
          open={settingsOpen}
          onClose={() => this.setState({ settingsOpen: false })}
          intl={intl}
          onSaved={() => {
            this.loadSettings();
            this.setState({
              snackOpen: true,
              snackVariant: 'success',
              snackMessage: intl.formatMessage({ id: 'save.success' }),
            });
          }}
        />
        <Footer />
      </div>
    );
  }
}

AnnouncementList.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(componentActions, dispatch);

const AnnouncementListConnected = injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AnnouncementList)));

AnnouncementList.contextType = AbilityContext;

function AnnouncementListWithHub(props) {
  let hubAnnouncementChange = null;
  try {
    const ctx = useAgentWorkspaceHubContext();
    hubAnnouncementChange = ctx && ctx.announcementChange ? ctx.announcementChange : null;
  } catch (e) {
    hubAnnouncementChange = null;
  }
  return <AnnouncementListConnected {...props} hubAnnouncementChange={hubAnnouncementChange} />;
}

export default AnnouncementListWithHub;
